import { render, staticRenderFns } from "./LegacyNotice.vue?vue&type=template&id=294ce190&scoped=true&"
import script from "./LegacyNotice.vue?vue&type=script&lang=js&"
export * from "./LegacyNotice.vue?vue&type=script&lang=js&"
import style0 from "./LegacyNotice.vue?vue&type=style&index=0&id=294ce190&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294ce190",
  null
  
)

export default component.exports